import { buildSparsePayload } from "./sparsePayload.js";

function sortComparableValue(value) {
  if (value === undefined) {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value.map((item) => sortComparableValue(item));
  }

  if (value && typeof value === "object") {
    const sortedEntries = Object.entries(value)
      .map(([key, nestedValue]) => [key, sortComparableValue(nestedValue)])
      .filter(([, nestedValue]) => nestedValue !== undefined)
      .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey));

    return sortedEntries.length > 0
      ? Object.fromEntries(sortedEntries)
      : undefined;
  }

  return value;
}

function toComparableFormValue(value) {
  return sortComparableValue(buildSparsePayload(value)) ?? null;
}

function areComparableFormValuesEqual(left, right) {
  return (
    JSON.stringify(toComparableFormValue(left)) ===
    JSON.stringify(toComparableFormValue(right))
  );
}

function hasComparableFormChanges(current, baseline) {
  return !areComparableFormValuesEqual(current, baseline);
}

export {
  areComparableFormValuesEqual,
  hasComparableFormChanges,
  toComparableFormValue,
};
